'use client';

import { useEffect, useRef } from 'react';

const InteractionEvents = ['scroll', 'click', 'mousemove', 'touchstart'];
const FallbackDelay = 10000;
const BingUetTagId = '343250959';
const MicrosoftClarityTagId = 'vtp0261qcu';

const LoadMicrosoftClarity = () => {
    window.clarity =
        window.clarity ||
        function () {
            (window.clarity.q = window.clarity.q || []).push(arguments);
        };

    if (
        document.querySelector(`script[src="https://www.clarity.ms/tag/${MicrosoftClarityTagId}"]`)
    ) {
        return;
    }

    const ScriptElement = document.createElement('script');
    ScriptElement.async = true;
    ScriptElement.src = `https://www.clarity.ms/tag/${MicrosoftClarityTagId}`;

    const FirstScript = document.getElementsByTagName('script')[0];
    FirstScript?.parentNode?.insertBefore(ScriptElement, FirstScript);
};

const LoadBingUet = () => {
    const QueueName = 'uetq';
    const Options = {
        ti: BingUetTagId,
        enableAutoSpaTracking: true,
        ts: new Date().getTime(),
    };

    window[QueueName] = window[QueueName] || [];

    if (document.querySelector(`script[src*="bat.bing.net/bat.js?ti=${BingUetTagId}"]`)) {
        return;
    }

    const ScriptElement = document.createElement('script');
    ScriptElement.src = `https://bat.bing.net/bat.js?ti=${Options.ti}`;
    ScriptElement.async = true;
    ScriptElement.onload = ScriptElement.onreadystatechange = function () {
        const ReadyState = this.readyState;

        if (ReadyState && ReadyState !== 'loaded' && ReadyState !== 'complete') {
            return;
        }

        if (typeof window.UET === 'function') {
            Options.q = window[QueueName];
            window[QueueName] = new window.UET(Options);
            window[QueueName].push('pageLoad');
        }

        ScriptElement.onload = null;
        ScriptElement.onreadystatechange = null;
    };

    const FirstScript = document.getElementsByTagName('script')[0];
    FirstScript?.parentNode?.insertBefore(ScriptElement, FirstScript);
};

/**
 * Injects third-party tracking scripts (Bing UET, Microsoft Clarity)
 * only after the user's first interaction (scroll, click, mousemove, touchstart)
 * or after a 10-second idle timeout, whichever comes first.
 */
const DeferredScripts = () => {
    const HasLoadedRef = useRef(false);

    useEffect(() => {
        let FallbackTimer;

        const LoadScripts = () => {
            if (HasLoadedRef.current) {
                return;
            }

            HasLoadedRef.current = true;

            InteractionEvents.forEach((EventName) => {
                window.removeEventListener(EventName, LoadScripts);
            });
            clearTimeout(FallbackTimer);

            LoadMicrosoftClarity();
            LoadBingUet();
        };

        InteractionEvents.forEach((EventName) => {
            window.addEventListener(EventName, LoadScripts, { once: true, passive: true });
        });

        FallbackTimer = setTimeout(LoadScripts, FallbackDelay);

        return () => {
            InteractionEvents.forEach((EventName) => {
                window.removeEventListener(EventName, LoadScripts);
            });
            clearTimeout(FallbackTimer);
        };
    }, []);

    return null;
};

export default DeferredScripts;
